// extracted by mini-css-extract-plugin
module.exports = {"personaDetailShiftLeft":"persona-role-step_personaDetailShiftLeft_3z-"};